/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, type Store } from '@atlassian/react-sweet-state';
import actions from './actions.tsx';
import type { Actions, State } from './types.tsx';

const initialState: State = {
	collapseStart: new Set(),
	collapseEnd: new Set(),
	expandStart: new Set(),
	expandEnd: new Set(),
};

const ExportedComponent: Store<State, Actions, unknown> = createStore<State, typeof actions>({
	name: 'navigation-ui',
	initialState,
	actions,
});
export default ExportedComponent;
